<template>
    <div class="footer">
        <div class="content">
            <div class="title">
                <div class="icon">
                    <img class="bgImage" src="@/images/home/1-27.png" alt="" />
                </div>
            </div>
            <div class="main">
                <p style="cursor: pointer;">
                    <a target="_blank" :style="$store.state.i18n?'':'font-size:2.2vw;'" href="http://beian.miit.gov.cn/state/outPortal/loginPortal.action">{{$store.state.i18n?componentsLang.phone.chinese.footer.reference.icp:componentsLang.phone.english.footer.reference.icp}}</a> 
                    <img style="margin: 0 1.417vw 0 1.625vw;height: 4vw;width: 3.6vw" src="@/images/home/1-43.png"> 
                    <a target="_blank" :style="$store.state.i18n?'':'font-size:2.2vw;'" href="http://beian.miit.gov.cn/state/outPortal/loginPortal.action">{{$store.state.i18n?componentsLang.phone.chinese.footer.reference.icp2:componentsLang.phone.english.footer.reference.icp2}}</a>
                </p>
                <p :style="$store.state.i18n?'':'font-size:2.3vw;'">{{$store.state.i18n?componentsLang.phone.chinese.footer.reference.copyRight:componentsLang.phone.english.footer.reference.copyRight}}</p>
                <p :style="$store.state.i18n?'':'font-size:2.3vw;'" style="cursor: pointer;"><a target="_blank" :href="privacyUrl">{{$store.state.i18n?componentsLang.phone.chinese.footer.reference.privacy:componentsLang.phone.english.footer.reference.privacy}}</a></p>
                <p :style="$store.state.i18n?'':'font-size:2.3vw;'">{{$store.state.i18n?componentsLang.phone.chinese.footer.reference.tel:componentsLang.phone.english.footer.reference.tel}}</p>
                <p>
                    <img style="marginRight: 1.417vw;width: 3vw;height: 3.48vw" src="@/images/home/1-47.png">
                    <span :style="$store.state.i18n?'':'font-size:2.3vw;'">{{$store.state.i18n?componentsLang.phone.chinese.footer.reference.qq:componentsLang.phone.english.footer.reference.qq}}</span>
                </p>
                <p :style="$store.state.i18n?'':'font-size:2.3vw;'">{{$store.state.i18n?componentsLang.phone.chinese.footer.reference.address:componentsLang.phone.english.footer.reference.address}}</p>
                <p>©2017 JDH Information Technology (Guangzhou) Co., Ltd All Rights Reserved</p>
            </div>
            <div class="lianjieORcode">
                <div class="lianjie">
                    <div class="title">{{$store.state.i18n?componentsLang.phone.chinese.footer.link.title:componentsLang.phone.english.footer.link.title}}</div>
                    <div class="neirong">
                        <p class="item">
                            <a target="_blank" :style="$store.state.i18n?'':'font-size:2vw;'" href="http://www.pbc.gov.cn/">{{$store.state.i18n?componentsLang.phone.chinese.footer.link.link1:componentsLang.phone.english.footer.link.link1}}</a>
                        </p>
                        <p class="item">
                            <a target="_blank" :style="$store.state.i18n?'':'font-size:2vw;'" href="http://www.shcpe.com.cn/content/shcpe/index.html">{{$store.state.i18n?componentsLang.phone.chinese.footer.link.link2:componentsLang.phone.english.footer.link.link2}}</a>
                        </p>
                        <p class="item">
                            <a target="_blank" :style="$store.state.i18n?'':'font-size:2vw;'" href="https://www.nifa.org.cn/nifa/index.html">{{$store.state.i18n?componentsLang.phone.chinese.footer.link.link3:componentsLang.phone.english.footer.link.link3}}</a>
                        </p>
                        <p class="item">
                            <a target="_blank" :style="$store.state.i18n?'':'font-size:2vw;'" href="https://www.tclmro.com/">{{$store.state.i18n?componentsLang.phone.chinese.footer.link.link4:componentsLang.phone.english.footer.link.link4}}</a>
                        </p>
                    </div>
                </div>
                <div class="code">
                    <div class="title">{{$store.state.i18n?componentsLang.phone.chinese.footer.qrCode.title:componentsLang.phone.english.footer.qrCode.title}}</div>
                    <div class="neirong">
                        <div class="qrCode">
                            <div class="image">
                                <img class="bgImage" src="@/images/home/1-25.png"/>
                            </div>
                            <div class="wenzi" :style="$store.state.i18n?'':'font-size:2vw;'">{{$store.state.i18n?componentsLang.phone.english.footer.qrCode.qrCode1:componentsLang.phone.english.footer.qrCode.qrCode1}}</div>
                        </div>
                            
                        <div class="qrCode">
                            <div class="image">
                                <img class="bgImage" src="@/images/home/1-26.png"/>
                            </div>
                            <div class="wenzi" :style="$store.state.i18n?'':'font-size:2vw;'">{{$store.state.i18n?componentsLang.phone.english.footer.qrCode.qrCode2:componentsLang.phone.english.footer.qrCode.qrCode2}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data () {
      return {
        privacyUrl: ''
      }
  },
  created () {
    this.getPrivacyUrl()
  },
  methods: {
    getPrivacyUrl () {
      this.privacyUrl = process.env.VUE_APP_OSS_PREFIX + '/newHome/protocol/简单汇信息科技个人信息及隐私保护政策.pdf'
    }
  }
}
</script>


<style scoped>
.bgImage{
    width:100%;height:100%;
    position: absolute;
    left:0;top:0;
}
.footer{
    width:100vw;height:97.33vw;
    background-color: #212121;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
}
.footer .content{
    width:89.33vw;height:100%;
    position: relative;
    /* background-color: orange; */
    padding-top:4vw;
    box-sizing: border-box;
}
.footer .content .title{
    width:100%;height:10.33vw;
    /* background-color: aquamarine; */
    border-bottom: 1px solid #545454;
    display: flex;
    align-items: center;
}
.footer .content .title .icon{
    width:15.6vw;height:4.4vw;
    position: relative;
}
.footer .content .main{
    width:100%;height:33.33vw;
    /* background-color: brown; */
    position: relative;
    margin-top:4vw;
    color: #707173;
}
.footer .content .main>p{
    white-space: nowrap;
    font-size: 2.5vw;
    -webkit-transform-origin-x: 0; 
    transform: scale(0.90);
    margin-bottom:0.8vw;
    /* background-color: aquamarine; */
}
.footer .content .main a{
    color: #707173;
}
.footer .content .lianjieORcode{
    width:100%;height:34.66vw;
    position: relative;
    /* background-color: coral; */
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.footer .content .lianjieORcode .lianjie{
    width:34.66vw;height:100%;
    position: relative;
    /* background-color: cornflowerblue; */
}
.footer .content .lianjieORcode .code{
    width:36vw;height:100%;
    position: relative;
    /* background-color: crimson; */
}
.footer .content .lianjieORcode .lianjie .title,
.footer .content .lianjieORcode .code .title{
    width:100%;height:10.66vw;
    border-bottom: 1px solid #545454;
    display: flex;
    align-items: center;
    color: #b4b5b7;
    font-size:3vw;
    font-weight: bold;
}
.footer .content .lianjieORcode .lianjie .neirong{
    width:100%;height:24vw;
    margin-top:1vw;
}
.footer .content .lianjieORcode .lianjie .neirong>p{
    white-space: nowrap;
    font-size: 3vw;
    -webkit-transform-origin-x: 0; 
    transform: scale(0.90);
    margin-bottom: 1vw;
}
.footer .content .lianjieORcode .lianjie .neirong a{
    color: #707173;
}
.footer .content .lianjieORcode .code .neirong{
    width:100%;height:24vw;
    margin-top:1vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.footer .content .lianjieORcode .code .neirong .qrCode{
  width:14.66vw;height:19.33vw;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  /* background-color: green; */
}
.footer .content .lianjieORcode .code .neirong .qrCode .image{
  width:14.66vw;height:14.66vw;
  position: relative;
}
.footer .content .lianjieORcode .code .neirong .qrCode .wenzi{
  width:125%;min-height:2.083vw;
  font-size: 3vw;
  -webkit-transform-origin-x: 0; 
  transform: scale(0.80) translateX(2.2vw);
  color: #707173;
  /* background-color: orangered; */
  margin-top:0.8vw;
}

</style>


// WEBPACK FOOTER //
// src/components/mobileFooter/index.vue